import React, { useState, useContext, useEffect } from "react";
import Button from "@material-ui/core/Button";
import InofficePage from "./inoffice/index";
import TeledermPage from "./telederm/index";
import {
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { AppointmentType, Context, Facility, FacilityRegion, Provider } from "./store/index";	//FB 4735 - Added reference  //FB 9735
import { modify_AppointmentDetails } from "./actions";
import useStyles from "./css/styles";
//FB 9735
import { GetAdminSettingValue, GetAllAppointmentTypes, GetFacilities, GetFacilityRegions, GetProviders, InsertPELogs } from "./api";	//FB 4735 - Added reference , FB 4960 , FB 6366
import globalsettings from "../../config";

// update log
// FB 4371 DK     03/29/2021    Landing page of the site
// FB 4522 DK     06/18/2021    Fixed variable type error
// FB 4574 DK     07/15/2021    UI fixes
// FB 4663 MS     09/01/2021    disabled telehealth button
// FB 4735 DK     10/11/2021    Implementation of provider specific workflow changes
// FB 4783 MS     10/29/2021    Fixed location specific url issue
// FB 4960 BR     07/03/2022    Logging all actions on PE
// FB 6366 SK     02/20/2023    Admin setting for TeleHealth appointment message
// FB 6986 KK     06/26/2023    Telehealth button should be enabled in PE by default
// FB 7801 SK     12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 8043 MS     01/05/2024    Hide/show Telehealth button based on admin setting
// FB 8012 SK     01/08/2024    PE - Appointment types
// FB 8142 SK     01/23/2024    Sophie - time slots are different when you go with by date vs. by provider flow
// FB 8214 SK     02/01/2024    Accept Case Sensitive Admin Setting Value for Enable PE Custom Appointments in API and Portal and PE
// FB 8259 SK     02/27/2024    After booking appt with card details when user click back button needs to be handled
// FB 9735 DK 	  12/05/2024    On PE Sites, In Office vs TeleHealh is the First Patient Choice. These Must be Restictions Here
// FB 9973 DK     01/28/2025    Failed to fetch: GET https://drsamemr.com/api/Provider/GetSlotsByDate

export default function Index(props: any) {
  const classes = useStyles();
  const { state, dispatch } = useContext(Context);
  const [appointmenttype, setAppointmenttype] = useState(
    state.appointmentdetails.appointmenttype
  );
  const [facilities, setFacilities] = React.useState<Facility>({
    id: 0,
    name: "",
    address: "",
    region: 0,
  });
  const [regions, setRegions] = React.useState<FacilityRegion>({
    id: 0,
    name: "",
    state: "",
  });
  //FB 4735 DK - Added to store provider details
  const [providers, setProviders] = React.useState<Provider>({
    id: 0,
    name: "",
    facility_n: 0,
    InsuranceAcceptance: "",
    bio: ""
  });
  let isDefaulted: boolean = false;
  const [inOfficeAppointmentTypesCount, setInOfficeAppointmentTypesCount] = useState(0);  //FB 9735
  const [teleAppointmentTypesCount, setTeleAppointmentTypesCount] = useState(0);  //FB 9735

  //FB 4371 DK    Added to preload the region in default location workflow
  function setregion(id: any) {
    GetFacilityRegions().then((data) => {
      if (data.length > 0) {
        let selectedregion: FacilityRegion = data.find(
          (option) => option.id.toString() === id
        ) as FacilityRegion;
        setRegions(selectedregion as FacilityRegion);
        state.defaultlocation.region = selectedregion.id;
      }
    });
  }

  //FB 4371 DK    Added to preload the facility in default location workflow
  function setlocation() {
    GetFacilities(0).then((data) => {
      if (data.length > 0) {
        //FB 4522 DK - Added type for option variable
        let selectedfacility: Facility = data.find(
          (option: any) => option.id.toString() === location
        ) as Facility;
        setFacilities(selectedfacility as Facility);
        state.defaultlocation = selectedfacility;
      }
    });
  }

  //FB 4735 DK - Added to preload the provider
  function setprovider() {
    GetProviders(0, state.appointmentdetails.appointmenttype).then((data) => {
      if (data.length > 0) {
        //FB 4522 DK - Added type for option variable
        let selectedprovider: Provider = data.find(
          (option: any) => option.id.toString() === provider
        ) as Provider;
        setProviders(selectedprovider as Provider);
        state.defaultprovider = selectedprovider;
      }
    });
  }

  let aptType = props.match.params.apt;
  let region = props.match.params.reg;
  let location = props.match.params.loc;
  let provider = props.match.params.provider;		//FB 4735 DK - Added to read provider from url

  if (aptType != undefined && region != undefined && location != undefined) {
    isDefaulted = true;
  }

  //FB 4735 DK - Added to set default provider workflow
  if (aptType != undefined && provider != undefined) {
    isDefaulted = true;
  }
  //FB 6366 SK - Function to load Telehealth Message
  const [message, setMessage] = useState("");
  async function GetTelehealthMessage() {
    setMessage(await GetAdminSettingValue("TeleHealthMessage"));
  }

  //FB 6986 KK Begin
  const [disableTelehealth, setDisableTelehealth] = useState(false);
  const [disableForm, setDisableForm] = useState(false);//FB 8012
  async function GetTelehealthButton() {
    const data = await GetAdminSettingValue("DisableTeleHealth_PE");
    //FB 9973
    //const customApptAdmin = (await GetAdminSettingValue("Enable PE Custom Appointments")).toLowerCase();//FB 8012 //FB 8214
    //sessionStorage.setItem("Enable PE Custom Appointments", customApptAdmin);//FB 8142
    if (data.toLowerCase() === "true") {  //FB 8043
      setDisableTelehealth(data);
    }
    //FB 8012 - Begin
    //FB 9973
    if (data == "true") {
      setDisableForm(true);
      handleClick("inoffice");
    }
    //FB 8012 - End
  }
  //FB 6986 KK End

  //FB 9735
  async function FetchAppointmentTypes() {
    var types: AppointmentType[] = await GetAllAppointmentTypes();
    if (types != null && types.length > 0) {
      setInOfficeAppointmentTypesCount(types.filter((type) => type.IS_TELE_APPOINTMENT == 0).length);
      setTeleAppointmentTypesCount(types.filter((type) => type.IS_TELE_APPOINTMENT == 1).length);
    }
  }

  useEffect(() => {
    sessionStorage.setItem("URL", window.location.href);//FB 8259
    GetTelehealthButton();//FB 6986 KK
    GetTelehealthMessage(); //FB 6366 SK
    FetchAppointmentTypes();  //FB 9735
    if (aptType === "1") {
      setAppointmenttype("inoffice");
      state.appointmentdetails.appointmenttype = "inoffice";
    } else if (aptType === "2") {
      setAppointmenttype("telederm");
      state.appointmentdetails.appointmenttype = "telederm";
    }

    if (region != null) {
      setregion(region);
    }

    if (location != null) {
      setlocation();
    }

    //FB 4735 DK - Set provider if not null
    if (provider != null) {
      setprovider();
    }
  }, []);

  //FB 4371 DK    Added to modify the state on selecting the appointment type

  const handleClick = (selected: string) => {
    setAppointmenttype(selected);
    //FB 4960 Start
    if (selected == "inoffice") {
      InsertPELogs(globalsettings.clientIp, "Selected inoffice");
    }
    else if (selected == "telederm") {
      InsertPELogs(globalsettings.clientIp, "Selected telederm");
    }
    //FB 4960 End
    modify_AppointmentDetails(
      {
        appointmenttype: selected,
        customappointmenttype: "",//FB 7801
        patientType: "",
        isInsuranceExist: "",
        insurance: {
          id: 0,
          planId: 0,
          name: "",
          planName: "",
        },
        appointmentfilter: "",
        provider: {
          id: 0,
          name: "",
        },
        location: {
          id: 0,
          name: "",
          address: "",
          region: 0,
        },
        date: new Date(),
      },
      dispatch
    );
  };

  //FB 4371 DK    Added to load the component based on selected appointment type
  function getcomponent() {
    switch (appointmenttype) {
      case "inoffice":
        return (
          <InofficePage
            onCallbackAppt={setAppointmenttype}
            type={state.appointmentdetails.appointmenttype}
            region={region}
          />
        );
        break;

      case "telederm":
        return (
          <TeledermPage
            onCallbackAppt={setAppointmenttype}
            type={state.appointmentdetails.appointmenttype}
          />
        );
        break;

      default:
        break;
    }
  }

  return (
    <div >
      <section
        style={{
          margin: "10px 20px 20px",
        }}
      >
        <Grid container spacing={2} style={{ display: disableForm ? "none" : "inline-block" }}>{/* FB 8012 */}
          <Grid item xs={12}>
            <Typography variant="h6">
              What type of appointment would you like to schedule?
            </Typography>
          </Grid>
          {/* FB 9735 */}
          <Grid
            item
            xs={6}
            md={3}
            lg={2}
            style={{
              display: appointmenttype === "telederm" || inOfficeAppointmentTypesCount == 0 ? "none" : "inline-flex",
            }}
          >
            <Button
              onClick={() => handleClick("inoffice")}
              variant="outlined"
              className={
                appointmenttype === "inoffice"
                  ? classes.buttonActive
                  : classes.buttonInactive
              }
            //endIcon={appointmenttype === "inoffice" ? <Tick/> :"" }
            >
              In Office
            </Button>
          </Grid>
          {/* FB 9735 */}
          <Grid
            item
            xs={6}
            md={3}
            lg={2}
            style={{
              display: appointmenttype === "inoffice" || teleAppointmentTypesCount == 0 ? "none" : "inline-flex",
            }}
          >
            <Button
              onClick={() => handleClick("telederm")}
              variant="outlined"
              className={
                appointmenttype === "telederm"
                  ? classes.buttonActive
                  : classes.buttonInactive
              }
              style={{ display: disableTelehealth ? "none" : "block" }} //FB 8043
            //disabled={disableTelehealth}  // FB 6986 disable or enable telehealth button from admin setting //FB 8043
            //disabled  //FB 4663 disabled telehealth button
            >
              {globalsettings.digitalApptType}
            </Button>
          </Grid>
          {/* FB 4574 DK - Added to notify user about tele appointment - Start */}
          <Grid
            item
            xs={6}
            style={{
              display: appointmenttype === "telederm" ? "flex" : "none",
              verticalAlign: "middle"
            }}
          >
            <Typography style={{ color: "red" }}>
              {/* FB 6366 SK - Telehealth Message from Admin Param */}
              {message}
            </Typography>
          </Grid>
          {/* FB 4574 DK - Added to notify user about tele appointment - End */}
        </Grid>
        {/* FB 4735 DK - Modified display condition */}
        <Grid
          container
          style={{
            display: regions.id > 0 && facilities.id > 0 ? "flex" : "none", //FB 4783 - provider id check isn't required in this workflow
            marginTop: "2%",
            marginBottom: "2%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={5}>
              <Typography variant="h6">
                Your selected office location
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} style={{ marginTop: "1%" }}>
            <TextField
              type="text"
              label="Office Location"
              variant="standard"
              className={classes.disabledTextfield}
              value={facilities.name}
              disabled
              inputProps={{ className: classes.disabledTextfield }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} style={{ marginTop: "1%" }}>
            <TextField
              label="Region"
              variant="standard"
              className={classes.disabledTextfield}
              value={regions.name}
              type="text"
              disabled
              inputProps={{ className: classes.disabledTextfield }}
            />
          </Grid>
        </Grid>
        {/* FB 4735 DK - Added grid to show provider name - Start  */}
        <Grid
          container
          style={{
            display: providers.id > 0 ? "flex" : "none",
            marginTop: "2%",
            marginBottom: "2%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={5}>
              <Typography variant="h6">
                Selected provider
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} style={{ marginTop: "1%" }}>
            <TextField
              type="text"
              label="Provider"
              variant="standard"
              className={classes.disabledTextfield}
              value={providers.name}
              disabled
              inputProps={{ className: classes.disabledTextfield }}
            />
          </Grid>
        </Grid>
        {/* FB 4735 DK - Added grid to show provider name - End  */}
        {/* FB 4735 DK - Modified condition  */}
        <React.Fragment>
          {isDefaulted
            ? (regions.id > 0 && facilities.id > 0) || providers.id > 0
              ? getcomponent()
              : ""
            : getcomponent()}
        </React.Fragment>
      </section>
    </div>
  );
}
